/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardVulnerabilitySummaryAccountResponse {
    getFixupPrototypeFunction() { return SecurityDashboardVulnerabilitySummaryAccountResponse.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardVulnerabilitySummaryAccountResponse>): SecurityDashboardVulnerabilitySummaryAccountResponse {
        let obj = Object.assign(new SecurityDashboardVulnerabilitySummaryAccountResponse(), model);
        SecurityDashboardVulnerabilitySummaryAccountResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardVulnerabilitySummaryAccountResponse>): SecurityDashboardVulnerabilitySummaryAccountResponse {
        if (!model) return null;
        return SecurityDashboardVulnerabilitySummaryAccountResponse.newInstance(<SecurityDashboardVulnerabilitySummaryAccountResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardVulnerabilitySummaryAccountResponse) {
        if (!obj) return;

        models.SecurityDashboardVulnerabilitySummaryAccountResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardVulnerabilitySummaryAccountResponse): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardVulnerabilitySummaryAccountResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.summary_by_accounts) {
            for (let val of this.summary_by_accounts) {
                models.SecurityDashboardVulnerabilityAccountDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Visibility of the vulnerabilities by Account
     */
    summary_by_accounts: Array<models.SecurityDashboardVulnerabilityAccountDetails>;

}
